/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_td_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Text Diff — Compare Two Texts Online | Toolverse`)
};

const es_td_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comparador de Textos — Comparar Dos Textos en Línea | Toolverse`)
};

const de_td_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Text-Diff — Vergleiche zwei Texte online | Toolverse`)
};

const nl_td_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tekstdiff — Vergelijk twee teksten online | Toolverse`)
};

const fr_td_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Diff textuel — Comparer deux textes en ligne | Toolverse`)
};

const it_td_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Differenze di testo — Confronta due testi online | Toolverse`)
};

const pt_br2_td_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Diferenças de Texto — Compare Dois Textos Online | Toolverse`)
};

const pt_td_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comparação de Texto — Compare Dois Textos Online | Toolverse`)
};

const ja_td_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`テキスト差分 — 2つのテキストをオンラインで比較 | Toolverse`)
};

const zh_td_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`文本比较 — 在线比较两段文本 | Toolverse`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const td_meta_title = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.td_meta_title(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("td_meta_title", locale)
	if (locale === "en") return en_td_meta_title(inputs)
	if (locale === "es") return es_td_meta_title(inputs)
	if (locale === "de") return de_td_meta_title(inputs)
	if (locale === "nl") return nl_td_meta_title(inputs)
	if (locale === "fr") return fr_td_meta_title(inputs)
	if (locale === "it") return it_td_meta_title(inputs)
	if (locale === "pt-BR") return pt_br2_td_meta_title(inputs)
	if (locale === "pt") return pt_td_meta_title(inputs)
	if (locale === "ja") return ja_td_meta_title(inputs)
	return zh_td_meta_title(inputs)
};